// Ember web design tokens — mirrors /app/mobile/src/theme.ts for one cohesive brand.
export const colors = {
  surface: "#F1F6F8",
  onSurface: "#16282E",
  surfaceSecondary: "#E2EDF0",
  surfaceTertiary: "#CFE1E6",
  surfaceInverse: "#10323A",
  onSurfaceInverse: "#F1F6F8",
  brand: "#1F6E7E",
  brandPrimary: "#1F6E7E",
  onBrandPrimary: "#F1F6F8",
  brandSecondary: "#3E97AD",
  brandTertiary: "#BFE0E6",
  onBrandTertiary: "#0E2E36",
  success: "#3F7D55",
  warning: "#A87A1E",
  error: "#B4493C",
  onError: "#F1F6F8",
  border: "#C4D8DD",
  borderStrong: "#1F6E7E",
  divider: "#DBE9EC",
  muted: "#5C7278",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  "2xl": 32,
  "3xl": 48,
};

export const radius = {
  sm: 6,
  md: 12,
  lg: 20,
  pill: 999,
};

const FR = "'Fraunces', Georgia, serif";
const NU = "'Nunito', system-ui, sans-serif";

export const fonts = {
  display: { fontFamily: FR, fontWeight: 400 },
  displaySemiBold: { fontFamily: FR, fontWeight: 600 },
  displayBold: { fontFamily: FR, fontWeight: 700 },
  text: { fontFamily: NU, fontWeight: 400 },
  textSemiBold: { fontFamily: NU, fontWeight: 600 },
  textBold: { fontFamily: NU, fontWeight: 700 },
  textExtraBold: { fontFamily: NU, fontWeight: 800 },
};

export const type = {
  base: 18,
  lg: 20,
  xl: 24,
  "2xl": 30,
  "3xl": 40,
};

// Centered mobile-width column for the companion app screens.
export const phoneColumn = {
  maxWidth: 560,
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  minHeight: "100vh",
  background: colors.surface,
  position: "relative",
};
